import { gql, useQuery } from "@apollo/client";
import { 
  FindRedemptionsByOfferIdAdmin,
  FindRedemptionsByOfferIdAdminResponse,
  QueryFindRedemptionsByOfferIdAdminArgs, 
} from "../../../../../schemaTypes";
import { useCallback } from "react";

export const findRedemptionsByOfferIdAdminQuery = gql`
  query FindRedemptionsByOfferIdAdmin(
    $offerId: String!
    $page: Int!
    $pageSize: Int!
    $duration: String!
  ) {
    findRedemptionsByOfferIdAdmin(
      offerId: $offerId
      page: $page
      pageSize: $pageSize
      duration: $duration
    ) {
        data {
            createdAt
            wallet {
                id
            }
            user {
                customer{
                    firstname
                    lastname
                    community {
                        id
                        alias
                    }
                }
            }
            redeemedCode
        }
        total
        page
        pageSize
        totalPages
    }
  }
`;

export interface WithFindRedemptionsByOfferIdAdmin {
 data: FindRedemptionsByOfferIdAdmin[]
 total: number;
 page: number;
 pageSize: number;
  totalPages: number;
  loading: boolean;
  loadMore: () => void;
  hasMoreOffers: boolean;
}

interface Props {
  variables: QueryFindRedemptionsByOfferIdAdminArgs;
  children: (data: WithFindRedemptionsByOfferIdAdmin) => React.ReactElement | null;
}

export const FindRedemptionsByOfferIdAdminController: React.FC<Props> = ({ children, variables }) => {
  const { data, loading, fetchMore } = useQuery<
    FindRedemptionsByOfferIdAdminResponse,
    QueryFindRedemptionsByOfferIdAdminArgs
  >(findRedemptionsByOfferIdAdminQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  // Subscription for new transactions (optional, adjust as needed)
//   useSubscription(newFindAllOffersAdminSubscription);

  const findRedemptionsByOfferIdAdminData = data?.data || [];
  const page = data?.page || variables.page;
  const pageSize = data?.pageSize || variables.pageSize;
  const total = data?.total || 0;
  const totalPages = data?.totalPages || 0;
  const hasMoreOffers = page < totalPages;

  const loadMore = useCallback(() => {
    if (!hasMoreOffers) return;
    fetchMore({
      variables: {
        ...variables,
        page: page + 1
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult || !fetchMoreResult.data) {
          return prev;
        }
        return {
          ...fetchMoreResult,
          findRedemptionsByOfferIdAdmin: {
            ...fetchMoreResult.data,
            data: [
              ...(prev?.data || []),
              ...(fetchMoreResult.data || [])
            ]
          }
        };
      }
    });
  }, [fetchMore, variables, page, hasMoreOffers]);

  return children({
    data: findRedemptionsByOfferIdAdminData as any,
    loading,
    loadMore,
    hasMoreOffers,
    page,
    pageSize,
    total,
    totalPages,
  });
};